export default {
  payout: 'Payout',
  payouts: 'Payouts',
  searchPlaceholder: 'Search by name',
  beneficiaries: 'Beneficiaries',
  type: 'Type',
  INDIVIDUAL: 'Individual',
  BUSINESS: 'Business',
  addBeneficiary: 'Add beneficiary',
  editBeneficiary: 'Edit beneficiary',
  iAmAdding: "I'm adding",
  selectCountry: 'Select a country',
  legalType: 'Legal type',
  legalName: 'Legal name',
  addIdentificationInfo: 'Add identification information',
  identificationMethod: 'Identification method',
  identificationNumber: 'Identification number',
  companyLegalName: 'Company legal name',
  addAddress: 'Add address',
  addContacts: 'Add contacts',
  transferType: 'Transfer type',
  selectTransferType: 'Select an transfer type',
  primaryDocument: 'Primary document',
  makePayout: 'Make payout',
  sendMoney: 'Send money',
  addAccount: 'Add account',
  editAccount: 'Edit account',
  sureAddOrEdit: 'Would you like to continue?',
  sureDelete: 'Are you sure delete this item?',
  unableToDeletePendingBeneficiary:
    'It is not possible to delete this beneficiary as it contains accounts in PENDING status.',
  unableToDeletePrimaryBeneficiary:
    'It is not possible to delete this beneficiary as it contains primary account.',
  deleteDescription: 'This action is irreversible!',
  inputPutName: "Input person's full name",
  toAccount: 'To account',
  fromAccount: 'From account',
  LIMIT_REACHED: 'Limit reached',
  NOT_SUFFICIENT_FUNDS: 'Not sufficient funds',
  transfer: 'Transfer {{amount}}',
  transferDone: 'Transfer done!',
  transferId: 'Transfer ID: {{id}}',
  transferDetails: 'Transfer details',
  transferDetailsPlaceholder: 'Input transfer details for the recipient',
  reference: 'Reference',
  convertedAmount: 'Converted amount',
  accountName: 'Account name',
  accountStatus: 'Status',
  setAsPrimary: 'Set this account as primary',
  setAsPrimaryTag: 'To be set as primary',
  primary: 'Primary',
  handbookIsNotConfigured: 'Identification information is not configured. Please, contact support.',
  deletePrimaryAccount:
    'Deleting Primary Account will stop transferring Money to your Bank account instantly!',
  addPrimaryAccount: 'Your Money will be transferred to this new Primary account.',
  editPrimaryAccount: 'Your Money will be transferred to this Primary account.',
  selectAccount: 'Choose an account',
};
